import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { NotificationModel, NotificationParams } from './notifications.model';

const SNACK_BAR_CLASS = 'app-snack-bar';
const SNACK_BAR_DURATION = 3000;

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly _snackBar = inject(MatSnackBar);

  public showSuccessNotification(
    message: string,
    params?: NotificationParams,
    duration?: number,
  ) {
    return this.showNotification({ type: 'success', message, params, duration });
  }

  public showErrorNotification(
    message: string,
    error?: HttpErrorResponse,
    params?: NotificationParams,
    duration?: number,
  ) {
    return this.showNotification({
      type: 'error',
      message,
      params,
      error,
      duration: duration ?? Number.POSITIVE_INFINITY,
    });
  }

  public showInfoNotification(
    message: string,
    params?: NotificationParams,
    duration?: number,
  ) {
    return this.showNotification({ type: 'info', message, params, duration });
  }

  public showNotification(notification: NotificationModel) {
    const data: NotificationModel =
      notification.type === 'error'
        ? {
            type: notification.type,
            message: getNotificationErrorMessage(notification),
            params: notification.params,
          }
        : notification;

    return this._snackBar.openFromComponent(NotificationComponent, {
      panelClass: [SNACK_BAR_CLASS, notification.type || 'warn'],
      data,
      duration: notification.duration ?? SNACK_BAR_DURATION,
    });
  }
}

function getNotificationErrorMessage(model: NotificationModel) {
  return (
    (model.error?.status === HttpStatusCode.BadRequest && model.error?.error?.message) ||
    model.message
  );
}
